import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            meta: { title: 'Home'},
            component: Home
        },
        {
            path: '/who-we-are',
            name: 'who',
            meta: {title: 'Who we are'},
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "who" */ './views/who-we-are.vue')
        },
        {
            path: '/about-john-fenwick',
            name: 'about',
            meta: {title: 'About John Fenwick'},
            component: () => import(/* webpackChunkName: "about" */ './views/about-john-fenwick.vue')
        },
        {
            path: '/contact-us',
            name: 'contact',
            meta: {title: 'Contact Us'},
            component: () => import(/* webpackChunkName: "contact" */ './views/contact-us.vue')
        },
        {
            path: '/history-of-freemasonry',
            name: 'history',
            meta: {title: 'History of Freemasonry'},
            component: () => import(/* webpackChunkName: "history" */ './views/history-of-freemasonry.vue')
        },
        {
            path: '/links',
            name: 'links',
            meta: {title: 'Links'},
            component: () => import(/* webpackChunkName: "links" */ './views/links.vue')
        },
        {
            path: '/prospective-members',
            name: 'prospective',
            meta: {title: 'Prospective Members Questionnaire'},
            component: () => import(/* webpackChunkName: "prospective" */ './views/prospective-members.vue')
        },
    ]
})
